// extracted by mini-css-extract-plugin
export default {"subPageWrapper":"subPageWrapper_subPageWrapper__z0uou"};